/**
 * ESLCarouselAutoplayEvent (esl:autoplay:change) event is dispatched by {@link ESLCarouselAutoplayMixin}
 * on the host {@link ESLCarousel} element when autoplay state changes.
 * It indicates whether autoplay is enabled or disabled, or notifies about the current autoplay cycle start.
 */
export class ESLCarouselAutoplayEvent extends Event {
    constructor(init) {
        super(ESLCarouselAutoplayEvent.NAME, { bubbles: false, cancelable: false });
        Object.assign(this, init);
    }
    static dispatch(plugin) {
        const { enabled, active, duration } = plugin;
        const event = new ESLCarouselAutoplayEvent({ enabled, active, duration });
        return plugin.$host.dispatchEvent(event);
    }
}
ESLCarouselAutoplayEvent.NAME = 'esl:autoplay:change';
